import styled from 'styled-components';
import ReactPlayer from 'react-player';

export const Video = styled(ReactPlayer)`
    background-color: black;
`;
